<template>
  <BreadCrumb PageTitle="Demandes de ramassage" />
  <PickupRequests />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import PickupRequests from "../../components/PickUp/PickupRequests.vue";

export default defineComponent({
  name: "PickupRequestsPage",
  components: {
    BreadCrumb,
    PickupRequests,
  },
});
</script>